(ns bedrock-ui.http.core
  (:require [clojure.set :as set]))

;; TODO Remove when a later version of cljs.ajax than 0.7.3 is available and this
;; function has returned to ajax.core
(defn success? [status]
  (some #{status} [200 201 202 204 205 206]))

(def reportable-server-errors (set (range 500 600)))
(def client-errors (set (range 400 500)))
(def not-reportable-client-errors #{401 404 403})
(def reportable-client-errors (set/difference client-errors not-reportable-client-errors))
